<template>
  <div id="app">
    <header-area :settings=settings></header-area>

    <router-view></router-view>
  </div>
</template>


<script>

import HeaderPrint from '@/components/layout/HeaderPrint';
import { mapGetters, mapActions } from 'vuex';


export default {

    name: 'Print',

    components: {
      HeaderArea:HeaderPrint,
    },

    methods: {
      ...mapActions({
        getOrCreateSetting: 'settings/getOrCreateSetting',
      })
    },

    computed: {
      ...mapGetters('settings', {
        settings: 'settings'
      }),

    },


}

</script>



// WEBPACK FOOTER //
// src/layouts/Print.vue